import { GeneratorBannerData, PrismicAPIResp } from '../HomepageStaticContent/types'
import { GeneratorBannerObj } from './types'

export const parseGeneratorBannerData = (data: PrismicAPIResp[]): GeneratorBannerObj => {
  const generatorBannerData = (data || [])?.reduce(
    (prismicSlices, slice) => {
      if (
        slice.slice_type === 'generator_banner_desktop' ||
        slice.slice_type === 'generator_banner_mobile'
      ) {
        prismicSlices[slice.slice_type] = slice as GeneratorBannerData
      }

      return prismicSlices
    },
    {
      generator_banner_desktop: {},
      generator_banner_mobile: {}
    } as GeneratorBannerObj
  )

  return generatorBannerData
}
